import { CbObj, stripHtml } from 'string-strip-html';

export function validWebURL(str: string): boolean {
  let url;
  try {
    url = new URL(str);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

export const validateEmail = (mail: string): boolean => {
  if (
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      mail
    )
  )
    return true;
  return false;
};

export const isCamelCase = (str: string): boolean => {
  if (
    str.includes('/') ||
    str.includes('\\') ||
    str.includes('.') ||
    str.includes('_') ||
    str.includes('-')
  )
    return false;
  return /[A-Z]/.test(str);
};

export const isLowerCase = (str: string): boolean => {
  if (
    str.includes('/') ||
    str.includes('\\') ||
    str.includes('.') ||
    str.includes('_') ||
    str.includes('-')
  )
    return false;
  return str === str.toLowerCase();
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isSingleWord = (str: any): boolean => {
  if (!(typeof str === 'string' || str instanceof String)) {
    return false;
  }
  const strings = str.split(' ');
  return strings.length === 1;
};

const removeStartEmptyLines = (value: string): string => {
  return value.replace(/^[\n\s]+/g, '');
};

const removeEndEmptyLines = (value: string): string => {
  return value.replace(/[\n\s]+$/g, '');
};

const removeNewLineIndents = (value: string): string => {
  return value.replace(/\n[\s]+/gi, '\n');
};

const removeExplicitReturns = (value: string): string => {
  return value.replace(/[\s]*\\r\\n[\s]*/gm, '\n');
};

const postFormatStrippedHtml = (value: string): string => {
  let v = removeExplicitReturns(value);
  v = removeStartEmptyLines(v);
  v = removeEndEmptyLines(v);
  v = removeNewLineIndents(v);

  return v.trim();
};

export const stripHTMLFromString = (
  str: string
): {
  isModified: boolean;
  result: string;
} => {
  const cb = (options: CbObj) => {
    const { deleteFrom, deleteTo, insert, rangesArr } = options;
    if (deleteFrom === null || deleteTo === null) {
      return;
    }
    const tag = str.substring(deleteFrom, deleteTo);
    const isEmailTag = /<[\w-.]+@([\w-]+.)+[\w-]{2,4}>$/gi.test(tag);

    if (isEmailTag) {
      return;
    }

    rangesArr.push(deleteFrom, deleteTo, insert);
  };

  const strippedValue = stripHtml(str, { cb });

  const isModified = str.length !== strippedValue.result.length;

  return {
    isModified,
    result: isModified ? postFormatStrippedHtml(strippedValue.result) : str
  };
};

export interface ValidateAndFormatOutput {
  isLink: boolean;
  isEmail: boolean;
  isModified: boolean;
  rawValue: string;
  value: string;
}

export const validateAndFormatStringAttribute = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  rawValue: any
): ValidateAndFormatOutput => {
  let value = rawValue;
  let isModified = false;
  const isLink = validWebURL(rawValue);
  const isEmail = validateEmail(rawValue);
  const isSingle = isSingleWord(rawValue);

  if (!isLink && !isEmail && isSingle) {
    if (isCamelCase(rawValue as string) || isLowerCase(rawValue as string)) {
      const { isModified: isStripped, result } = stripHTMLFromString(rawValue);
      isModified = isStripped;
      value = result;
    }
  }

  if (!isLink && !isEmail && !isSingle && typeof rawValue === 'string') {
    const { isModified: isStripped, result } = stripHTMLFromString(rawValue);
    isModified = isStripped;
    value = result;
  }

  return {
    isLink,
    isEmail,
    isModified,
    rawValue,
    value
  };
};
